import { CharacterNameValues } from './vehicle/Character';
import { Level, LevelNameValues } from './level/levels/level';

// Static settings.
export interface RunSettings {
  [RunSettingsHandler.keys.InstantRestart]: boolean;
  [RunSettingsHandler.keys.RegenOnRestart]: boolean;
  [RunSettingsHandler.keys.SelectedLevel]: LevelNameValues;
  [RunSettingsHandler.keys.ChargesToCollect]: number;
}

// Values that need to change over the course of play e.g. player lives.
export interface RunSettingsActive extends RunSettings {
  [RunSettingsHandler.keys.ChargesCollected]: number;
}

/**
 * Stores a copy of any provided RunSettings in the scene's registry and can
 * rest them back to the original values.
 */
export class RunSettingsHandler {
  public static keys = {
    InstantRestart: 'instantRestart',
    RegenOnRestart: 'regenOnRestart',
    SelectedLevel: 'selectedLevel',
    ChargesToCollect: 'chargesToCollect',
    ChargesCollected: 'chargesCollected'
  } as const;

  public static events = {
    ChangeChargesCollected: `changedata-${RunSettingsHandler.keys.ChargesCollected}`,
  } as const;

  protected scene: Phaser.Scene;
  protected runSettings: RunSettings;

  constructor(scene: Phaser.Scene, runSettings: RunSettings) {
    this.scene = scene;
    this.runSettings = runSettings;

    this.resetData();
  }

  public resetData() {
    let settings: RunSettingsActive = Object.assign(
      {
        [RunSettingsHandler.keys.ChargesCollected]: 0
      },
      this.runSettings
    );

    this.scene.registry.set(settings);
  }

  public static collectCharge(scene: Phaser.Scene, amount: number) {
    scene.registry.inc(RunSettingsHandler.keys.ChargesCollected, amount);
  }

  public static hasCollectedAllCharges(scene: Phaser.Scene): boolean {
    console.log("CHARGE "+scene.registry.get(RunSettingsHandler.keys.ChargesCollected) +" "+scene.registry.get(RunSettingsHandler.keys.ChargesToCollect));
    return scene.registry.get(RunSettingsHandler.keys.ChargesCollected) >= scene.registry.get(RunSettingsHandler.keys.ChargesToCollect);
  }

  public static getSelectedLevel(scene: Phaser.Scene): LevelNameValues {
    return scene.registry.get(RunSettingsHandler.keys.SelectedLevel);
  }
}
